// @ai-generated 2026-08-27T00:00:00+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
import { type LinkedRequisition } from '@Hooks/Billing';
import { useClientNavigate } from '../../../Routing/useClientNavigate';
import {
    Button,
    defaultIconSize,
    FlexColumn,
    Modal,
    useModalState,
    useTranslate,
} from '@synqo/frontend-component-library';
import { IconClipboardList } from '@tabler/icons-react';
import { useCallback, type FC } from 'react';

export interface InvoiceSnapshotRequisitionButtonProps {
    /** The distinct requisitions this invoice touches, as resolved by the frame around the button. */
    requisitions: LinkedRequisition[];
}

/**
 * Header button leading from an invoice back to the requisition it was billed for. An invoice can
 * bill several orders, and those orders can belong to different requisitions, so more than one target
 * is possible - in that case the user picks.
 */
export const InvoiceSnapshotRequisitionButton: FC<InvoiceSnapshotRequisitionButtonProps> = ({ requisitions }) => {
    const i18n = useTranslate('');
    const navigate = useClientNavigate();
    const { isOpen, open, close } = useModalState();

    const goTo = useCallback(
        (requisitionId: string) => {
            close();
            navigate(`requisitions/${requisitionId}`);
        },
        [close, navigate],
    );

    const onClick = useCallback(() => {
        if (requisitions.length === 1) {
            goTo(requisitions[0].requisitionId);
            return;
        }
        open();
    }, [requisitions, goTo, open]);

    if (requisitions.length === 0) {
        return null;
    }

    return (
        <>
            <Button
                key="requisition"
                onClick={onClick}
                appearance="transparent"
                label={i18n('Zur Bestellung')}
                tooltip={i18n('Zur Bestellung')}
            >
                <IconClipboardList size={defaultIconSize} />
            </Button>
            <Modal isOpen={isOpen} onClose={close} title={i18n('Zur Bestellung')}>
                <FlexColumn gap="sm">
                    {requisitions.map((requisition: LinkedRequisition) => (
                        <Button
                            key={requisition.requisitionId}
                            onClick={() => goTo(requisition.requisitionId)}
                            appearance="transparent"
                            label={`${i18n('Auftrag')} ${requisition.orderNumber}`}
                        />
                    ))}
                </FlexColumn>
            </Modal>
        </>
    );
};
